import React from "react";
import { getTrackBackground, Range } from "react-range";
import { formatNumber } from "../../../helpers/common.helpers";
import "./rangeSlider.scss";

const RangeSlider = ({ min, max, values, setValues, onChange, activeColor = '#0E4BF0', inactiveColor = '#C3C7D1', }) => {
  const handleChange = (newValues) => {
    setValues(newValues);
    onChange(newValues[0]);
  };

  const renderTrack = ({ props, children }) => {
    const trackBackground = getTrackBackground({
      values,
      colors: [activeColor, inactiveColor],
      min,
      max,
    });
    
    return (
      <div
        {...props}
        className="track"
        style={{ background: trackBackground }}
      >
        {children}
      </div>
    );
  };

  const renderThumb = ({ props }) => <div {...props} className="thumb" />;

  return (
    <div className="range-container">
      <Range
        step={1}
        min={min}
        max={max}
        values={values}
        onChange={handleChange}
        renderTrack={renderTrack}
        renderThumb={renderThumb}
      />
      <div className="range-labels">
        <span className="auto-label">{formatNumber(min)}</span>
        <span className="auto-label">{formatNumber(max)}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
